<div class="px-6 py-4 w-full bg-aguacate-bg rounded-lg">
  <div class="flex flex-row justify-between items-center">
    <div><b>{{cuenta?.nombre}} {{cuenta?.apellidos}}</b></div>
    <button
      [matMenuTriggerFor]="menu"
      aria-label="Opciones del pagador"
      style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="actualizar()">
        <mat-icon style="color: #2563eb;">edit</mat-icon>
        <span>Editar</span>
      </button>
      <button mat-menu-item (click)="inactivarCuenta()">
        <mat-icon style="color: #dc2626;">delete</mat-icon>
        <span>Eliminar</span>
      </button>
    </mat-menu>
  </div>
</div>